import { render, staticRenderFns } from "./FiltrosGestion.vue?vue&type=template&id=87d52b1c&"
import script from "./FiltrosGestion.vue?vue&type=script&lang=js&"
export * from "./FiltrosGestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports